import { useEffect, useState } from "react";
import ReportFlareVocEmissionTable from "./components/ReportFlareVocEmissionTable";
import { useSearchParams } from "react-router-dom";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { reportFlareStore } from "src/stores/report-flare-volume-store";
import { Spin } from "antd";
import { excelStore } from "src/stores/excel-store.interface";

let isRequestCompany: string | null = null;
const ReportFlareVocEmission = () => {
  const currentYear = new Date().getFullYear();
  const [isDone, setIsDone] = useState(false);

  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const profile = profileStore(useShallow((state) => state.profile));
  const requestProfile = profileStore(useShallow((state) => state.requestProfile));

  const loadingCalculateReport = reportFlareStore(useShallow((state) => state.loadingCalculateReport));
  const loadingCalculateReportAfterChangeMaster = reportFlareStore(useShallow((state) => state.loadingCalculateReportAfterChangeMaster));
  const loadingCalculateReportWhenRejectApproval = reportFlareStore(useShallow((state) => state.loadingCalculateReportWhenRejectApproval));
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));

  useEffect(() => {
    if (!loadingCalculateReport && !loadingCalculateReportAfterChangeMaster && !loadingCalculateReportWhenRejectApproval) {
      setIsDone(true);
    }
  }, [loadingCalculateReport, loadingCalculateReportAfterChangeMaster, loadingCalculateReportWhenRejectApproval]);

  useEffect(() => {
    if (profile?.company && profile.company.length > 0 && companyId && (!isRequestCompany || isRequestCompany != companyId)) {
      const findSlot = profile.company.find((item) => item._id == companyId);
      if (findSlot) {
        requestProfile({ companyId: companyId });
        isRequestCompany = companyId;
      } else {
        window.location.pathname = "/unauthorized";
      }
    }
  }, [profile?.company]);

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);

  if (!isDone) return <Spin spinning />;
  return <ReportFlareVocEmissionTable />;
};

export default ReportFlareVocEmission;
// http://localhost:3000/vocs-inventory/flare/report-voc-emission?approveId=66d0b7844d4f7e916fae9338&companyId=66a32c0aa3d1da9e2e5efeac
// https://chem-voc-dev-ajgjcfczf2fhc5g4.a01.azurefd.net/vocs-inventory/flare/report-voc-emission?approveId=66e33e7263e34bf1d47efb88&companyId=66bb6a4ef4b11fb395a198b3
